const LOGIN_PATH = '/login';
const FORGOT_PASSWORD_PATH = '/forgot-pass';
const RECOVER_PASSWORD_PATH = '/recover-pass';
const ACCOUNT_PATH = '/account';
const ACCOUNT_PATH_ADD = `${ACCOUNT_PATH}/add`;
const ACCOUNT_PATH_EDIT = `${ACCOUNT_PATH}/edit`;
const LOGIN_HISTORY_PATH = '/login-history';
const STATISTIC_HISTORY_PATH = '/statistic-login-history';

const EMAILCONFIG_PATH = '/emailconfig';
const EMAILCONFIG_CREATE_PATH = '/emailconfig/create';
const EMAILCONFIG_EDIT_PATH = '/emailconfig/edit';

const LOG_PATH = '/log';

const REPORT_POST_PATH = '/report-post';
const REPORT_POST_SYNTHETIC_PATH = '/report-post-synthentic';
const REPORT_POST_EXCEL_PATH = '/report-post-excel';
const REPORT_POST_EXCEL_QUANTITY_CREATE_BY =
    '/report-post-excel-quantity-createby';
const REPORT_POST_EXCEL_CREATE_BY = '/report-post-excel-createby';

const REPORT_POST_WEBANALYSIS_PATH = '/report-post-web-analysis';
const REPORT_POST_BY_DATETYPE = '/report-post-by-datetype';
const REPORT_POST_VIEW_DETAIL = '/report-post-view-detail';
const REPORT_POST_PUBLISHTIME_DATATYPE_PATH =
    '/report-post-publish-time-data-type';
const REPORT_ADVERTISING_ANALYSIS_PATH = '/advertising-analysis';
const REPORT_COUNT_VISIT_DETAIL = '/report-count-visit-detail';

const GIAMSATCHINHSUAPHANMEM_PATH = '/giam-sat-chinh-sua-phan-mem';
const GIAMSATCHINHSUAPHANMEM_CREATE_PATH = `${GIAMSATCHINHSUAPHANMEM_PATH}/them`;
const GIAMSATCHINHSUAPHANMEM_EDIT_PATH = `${GIAMSATCHINHSUAPHANMEM_PATH}/sua`;

const GIAMSATCHINHSUADULIEUBENHVIEN_PATH = '/giam-sat-chinh-sua-du-lieu-benh-vien';
const GIAMSATCHINHSUADULIEUBENHVIEN_CREATE_PATH = `${GIAMSATCHINHSUADULIEUBENHVIEN_PATH}/them`;
const GIAMSATCHINHSUADULIEUBENHVIEN_EDIT_PATH = `${GIAMSATCHINHSUADULIEUBENHVIEN_PATH}/sua`;

const DONVIDENGHI_PATH = '/don-vi-de-nghi';
const DONVIDENGHI_CREATE_PATH = `${DONVIDENGHI_PATH}/them`;
const DONVIDENGHI_EDIT_PATH = `${DONVIDENGHI_PATH}/sua`;

const NOIDUNGDENGHIDANHSACH_PATH = '/noi-dung-de-nghi';
const NOIDUNGDENGHIDANHSACH_CREATE_PATH = `${NOIDUNGDENGHIDANHSACH_PATH}/them`;
const NOIDUNGDENGHIDANHSACH_EDIT_PATH = `${NOIDUNGDENGHIDANHSACH_PATH}/sua`;

const LYDODENGHIDANHSACH_PATH = '/ly-do-de-nghi';
const LYDODENGHIDANHSACH_CREATE_PATH = `${LYDODENGHIDANHSACH_PATH}/them`;
const LYDODENGHIDANHSACH_EDIT_PATH = `${LYDODENGHIDANHSACH_PATH}/sua`;

const ACCOUNTHIS_PATH = '/tai-khoan-his';
const ACCOUNTHIS_CREATE_PATH = `${ACCOUNTHIS_PATH}/them`;
const ACCOUNTHIS_EDIT_PATH = `${ACCOUNTHIS_PATH}/sua`;

const CHINHSUABAOHIEM_PATH = '/chinh-sua-bao-hiem';
const CHINHSUABAOHIEM_CREATE_PATH = `${CHINHSUABAOHIEM_PATH}/them`;
const CHINHSUABAOHIEM_EDIT_PATH = `${CHINHSUABAOHIEM_PATH}/sua`;

const ACCOUNTDENGHI_PATH = '/tai-khoan-de-nghi';
const ACCOUNTDENGHI_CREATE_PATH = `${ACCOUNTDENGHI_PATH}/them`;
const ACCOUNTDENGHI_EDIT_PATH = `${ACCOUNTDENGHI_PATH}/sua`;

const DynamicGoiThau = '/dynamic';
const DynamicStep = '/step';
const PROJECT_PATH = '/project';


const BAOCAO_PATH = '/bao-cao';
const WELCOME_PATH = '/welcome';
const BAI_BAO_PATH = '/bai-bao-cong-bo';
const DE_TAI_PATH = '/nhiem-vu-khcn';
const SANG_CHE_PATH = '/sang-che';
const GIAI_THUONG_PATH = '/giai-thuong';
const SACH_PATH = '/sach';
const HUONG_DAN_HOC_VIEN_PATH = '/huong-dan-hoc-vien';
const GIAI_THUONG_DAO_TAO_PATH = '/giai-thuong-dao-tao';
const DANH_MUC_DON_VI = '/danh-muc-don-vi';
const DANH_MUC_HOC_VI = '/danh-muc-hoc-vi';
const DANH_MUC_CHUC_DANH = '/danh-muc-chuc-danh-khoa-hoc';
const DANH_MUC_CHUC_VU = '/danh-muc-chuc-vu';

export const URI_INTERNAL = {
    REPORT_ADVERTISING_ANALYSIS_PATH,
    REPORT_POST_VIEW_DETAIL,
    REPORT_POST_BY_DATETYPE,
    REPORT_POST_EXCEL_CREATE_BY,
    REPORT_POST_EXCEL_QUANTITY_CREATE_BY,
    REPORT_POST_SYNTHETIC_PATH,
    REPORT_POST_PATH,
    RECOVER_PASSWORD_PATH,
    FORGOT_PASSWORD_PATH,
    ACCOUNT_PATH_EDIT,
    ACCOUNT_PATH_ADD,
    LOGIN_PATH,
    DynamicGoiThau,
    DynamicStep,
    PROJECT_PATH,
    ACCOUNT_PATH,
    LOGIN_HISTORY_PATH,
    EMAILCONFIG_PATH,
    EMAILCONFIG_CREATE_PATH,
    EMAILCONFIG_EDIT_PATH,
    STATISTIC_HISTORY_PATH,
    LOG_PATH,
    REPORT_POST_EXCEL_PATH,
    REPORT_POST_WEBANALYSIS_PATH,
    REPORT_POST_PUBLISHTIME_DATATYPE_PATH,
    REPORT_COUNT_VISIT_DETAIL,

    GIAMSATCHINHSUAPHANMEM_PATH,
    GIAMSATCHINHSUAPHANMEM_CREATE_PATH,
    GIAMSATCHINHSUAPHANMEM_EDIT_PATH,

    GIAMSATCHINHSUADULIEUBENHVIEN_PATH,
    GIAMSATCHINHSUADULIEUBENHVIEN_CREATE_PATH,
    GIAMSATCHINHSUADULIEUBENHVIEN_EDIT_PATH,

    DONVIDENGHI_PATH,
    DONVIDENGHI_CREATE_PATH,
    DONVIDENGHI_EDIT_PATH,

    ACCOUNTHIS_PATH,
    ACCOUNTHIS_CREATE_PATH,
    ACCOUNTHIS_EDIT_PATH,

    NOIDUNGDENGHIDANHSACH_PATH,
    NOIDUNGDENGHIDANHSACH_CREATE_PATH,
    NOIDUNGDENGHIDANHSACH_EDIT_PATH,

    LYDODENGHIDANHSACH_PATH,
    LYDODENGHIDANHSACH_CREATE_PATH,
    LYDODENGHIDANHSACH_EDIT_PATH,

    CHINHSUABAOHIEM_PATH,
    CHINHSUABAOHIEM_CREATE_PATH,
    CHINHSUABAOHIEM_EDIT_PATH,

    ACCOUNTDENGHI_PATH,
    ACCOUNTDENGHI_CREATE_PATH,
    ACCOUNTDENGHI_EDIT_PATH,

    BAOCAO_PATH,
    WELCOME_PATH,
    BAI_BAO_PATH,
    DE_TAI_PATH,
    SANG_CHE_PATH,
    GIAI_THUONG_PATH,
    SACH_PATH,
    HUONG_DAN_HOC_VIEN_PATH,
    GIAI_THUONG_DAO_TAO_PATH,
    PROFILE_CV: '/profile-cv',
    NHAN_VIEN_INPUT: '/nhan-vien',
    DANH_MUC_DON_VI,
    DANH_MUC_HOC_VI,
    DANH_MUC_CHUC_DANH,
    DANH_MUC_CHUC_VU
};
